"use client";
import t, { useState as J, useContext as K, useEffect as Q } from "react";
import S from "./ui-components/media/images/ImageLoaderV3.js";
import U from "./stamp/index.js";
import { SetLink as Y } from "./setLink.js";
import { Countdown as Z } from "../countdown/countdown.js";
import { uuidv4 as B, useWindowSize as ee, parseClassNames as te, isEmpty as w } from "@ddg-frontend/fe-essentials";
import { getBreakSizeDesktop as le } from "../../utils/breakpoints.js";
import { PropsContext as ne } from "../../context/context.js";
import ae from "./heading/index.js";
import se from "../../utils/extractTokenValue.js";
import { parseBackgroundColor as H } from "../../utils/configs-parser/parseBackgroundColor.js";
const p = (e) => e.hyperlinks.map((n, l) => {
  if (n.url)
    return /* @__PURE__ */ t.createElement("li", { key: l }, /* @__PURE__ */ t.createElement(Y, { fakeLinks: e.fakeLinks, hyperlink: n }));
}), be = (e) => /* @__PURE__ */ t.createElement(
  S,
  {
    ...e.itemImage,
    styles: (e.itemImage.styles ? e.itemImage.styles + " " : "") + (e.itemImage.is3d ? "is3d" : ""),
    lazyLoading: !0
  }
), _e = (e) => /* @__PURE__ */ t.createElement("div", { className: "image-holder" }, /* @__PURE__ */ t.createElement("div", { className: "image-wrap" }, e.children)), Ie = (e) => {
  const { textColor: n, textAlignment: l, textPosition: a, labels: c } = e;
  let i = B();
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: "text-holder " + n + " " + l + " " + a
    },
    /* @__PURE__ */ t.createElement("div", { className: "text-wrap" }, e.icons && e.icons != null && e.icons.length > 0 ? /* @__PURE__ */ t.createElement(M, { icons: e.icons }) : e.iconsImage ? /* @__PURE__ */ t.createElement(re, { iconsImage: e.iconsImage[0] }) : null, /* @__PURE__ */ t.createElement($, { labels: c, uuid: i }), /* @__PURE__ */ t.createElement(ie, { text: e.texts }), /* @__PURE__ */ t.createElement(ce, { text: e.texts }), /* @__PURE__ */ t.createElement(oe, { text: e.texts }), /* @__PURE__ */ t.createElement(me, { text: e.texts }), e.hyperlinks && e.hyperlinks.length > 0 ? /* @__PURE__ */ t.createElement("ul", { className: "hyperlinks" }, /* @__PURE__ */ t.createElement(p, { hyperlinks: e.hyperlinks })) : null, e.children)
  );
}, Le = (e) => {
  const {
    textColor: n = null,
    textAlignment: l = null,
    backgroundColor: a = null,
    // em Alguns casos como as colunas o bg color do item pode ter que ser declarado aqui
    labels: c = null,
    icons: i = null,
    iconsImage: u,
    hyperlinks: s,
    texts: o,
    stamp: g,
    countdown: T = null,
    // Só vai ser usado para já no multimedia, colunas e mosaico
    itemsOrder: x = [
      "countdown",
      "icons",
      "labels",
      "texts",
      "stamp",
      "hyperlinks",
      "children"
    ],
    // array with items order
    textsOrder: W = ["title", "subTitle", "additionalText", "description"],
    // array with texts order
    //todo this is temp, later will substitute the itemsOrder & textsOrder
    //todo and go from null to [defaults]
    itemsLayout: h = null,
    // can be flat or grouped (array of arrays)
    titleClassName: A = "",
    subTitleClassName: F = "",
    additionalTextClassName: D = "",
    descriptionClassName: O = "",
    labelsClassName: z = "",
    iconsImageClassName: V = "",
    textWrapRef: b = null,
    fakeLinks: j = !1
  } = e;
  let q = B();
  const [G, _] = J(""), { width: P } = ee(), m = K(ne);
  Q(() => {
    m && m.configs ? _(m.configs.siteContext) : _("meo");
  }, [m]);
  const y = (d, r) => {
    var C;
    switch (d) {
      case "countdown":
        return T && /* @__PURE__ */ t.createElement(
          Z,
          {
            key: r,
            endDate: T.endDate,
            endMessage: T.messageEnd,
            title: T.messageBefore
          }
        );
      case "icons": {
        if ((i == null ? void 0 : i.length) > 0)
          return /* @__PURE__ */ t.createElement(M, { key: r, icons: i });
        const f = !w(u == null ? void 0 : u.viewports);
        //! here the imageXS means its the mobile logo detail.
        //! and if doesnt exist and we are in desktop we dont print
        const E = !w((C = u == null ? void 0 : u.viewports) == null ? void 0 : C.imageXS), k = P >= le(G);
        return f && (k || E) ? /* @__PURE__ */ t.createElement(
          S,
          {
            key: r,
            itemImage: u,
            lazyLoading: !0,
            styles: V
          }
        ) : null;
      }
      case "labels":
        return /* @__PURE__ */ t.createElement(
          $,
          {
            key: r,
            labels: c,
            uuid: q,
            labelsClassName: z
          }
        );
      case "title":
      case "subTitle":
      case "additionalText":
      case "description":
      case "texts": {
        const f = (E, k) => {
          var v;
          return /* @__PURE__ */ t.createElement(
            ae,
            {
              key: k,
              type: E,
              content: o,
              parent: m == null ? void 0 : m.context,
              startHeading: se(
                (v = m == null ? void 0 : m.configs) == null ? void 0 : v.extraConfigs,
                "startHeading="
              ),
              extraClasses: {
                title: A,
                subTitle: F,
                additionalText: D,
                description: O
              }
            }
          );
        };
        return d !== "texts" ? f(d, r) : W.map(
          (E, k) => o != null && o[E] ? f(E, k) : null
        );
      }
      case "hyperlinks":
        return s && s.length > 0 ? /* @__PURE__ */ t.createElement("ul", { key: r, className: "hyperlinks" }, /* @__PURE__ */ t.createElement(p, { hyperlinks: s, fakeLinks: j })) : null;
      case "stamp":
        return g ? /* @__PURE__ */ t.createElement(U, { key: r, data: g }) : null;
      case "children":
        return e.children;
      default:
        return null;
    }
  }, R = te([
    "text-holder",
    n,
    l,
    H(a, "class")
  ]), X = (d, r, C) => /* @__PURE__ */ t.createElement("div", { key: r, className: "text-wrap" }, d.map((f, E) => y(f, E)), C && !L.includes("children") ? e.children : null), I = Array.isArray(h) && Array.isArray(h[0]), L = I ? h.flat() : h;
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: R,
      style: H(a, "style")
    },
    h ? /* @__PURE__ */ t.createElement(t.Fragment, null, I ? h.map(
      (d, r) => X(d, r, h.length - 1 == r)
    ) : /* @__PURE__ */ t.createElement("div", { className: "text-wrap", ref: b }, h.map((d, r) => y(d, r)), L.includes("children") ? null : e.children)) : (
      //todo this is deprecated to be removed when itemsLayout is fully implemented
      /* @__PURE__ */ t.createElement("div", { className: "text-wrap", ref: b }, y(x[0]), y(x[1]), y(x[2]), y(x[3]), y(x[4]), y(x[5]), x.includes("children") ? null : e.children)
    )
  );
}, N = (e) => {
  const {
    type: n,
    value: l,
    titleClassName: a,
    subTitleClassName: c,
    additionalTextClassName: i,
    descriptionClassName: u
  } = e, s = { __html: l };
  switch (n) {
    case "title":
      if (s.__html.startsWith(">h")) {
        let o = s.__html.slice(2, 3);
        s.__html = s.__html.substr(4);
        const g = `h${o}`;
        return /* @__PURE__ */ t.createElement(
          g,
          {
            className: "title-level-title " + a,
            dangerouslySetInnerHTML: s
          }
        );
      } else
        return /* @__PURE__ */ t.createElement(
          "h2",
          {
            className: "title-level-title " + a,
            dangerouslySetInnerHTML: s
          }
        );
    case "subTitle":
      if (s.__html.startsWith(">h")) {
        let o = s.__html.slice(2, 3);
        s.__html = s.__html.substr(4);
        const g = `h${o}`;
        return /* @__PURE__ */ t.createElement(
          g,
          {
            className: "title-level-sub-title " + c,
            dangerouslySetInnerHTML: s
          }
        );
      } else
        return /* @__PURE__ */ t.createElement(
          "h3",
          {
            className: "title-level-sub-title " + c,
            dangerouslySetInnerHTML: s
          }
        );
    case "additionalText":
      if (s.__html.startsWith(">h")) {
        let o = s.__html.slice(2, 3);
        s.__html = s.__html.substr(4);
        const g = `h${o}`;
        return /* @__PURE__ */ t.createElement(
          g,
          {
            className: "title-level-additional-text " + i,
            dangerouslySetInnerHTML: s
          }
        );
      } else
        return /* @__PURE__ */ t.createElement(
          "h4",
          {
            className: "title-level-additional-text " + i,
            dangerouslySetInnerHTML: s
          }
        );
    case "description":
      return /* @__PURE__ */ t.createElement("p", { dangerouslySetInnerHTML: s, className: u });
    default:
      return console.warn("Block columns does not support text of mode " + n), null;
  }
}, M = (e) => /* @__PURE__ */ t.createElement("span", { className: e.icons.map((n) => n).join(" ") }), re = (e) => (
  // #todo ainda não aplicado na imagem do tipo logo. VER BLOCK LINKS MOSAICO ETC
  // aplicado no block Links localmente
  /* @__PURE__ */ t.createElement(
    S,
    {
      ...e.image,
      styles: (e.image.styles ? e.image.styles + " " : "") + (e.image.is3d ? "is3d" : "")
    }
  )
), ie = (e) => {
  const n = e.text.filter(
    (l) => l.type === "title" ? l : null
  );
  return /* @__PURE__ */ t.createElement(t.Fragment, null, n.length > 0 ? /* @__PURE__ */ t.createElement(N, { ...n[0] }) : null);
}, ce = (e) => {
  const n = e.text.filter(
    (l) => l.type === "subTitle" ? l : null
  );
  return /* @__PURE__ */ t.createElement(t.Fragment, null, n.length > 0 ? /* @__PURE__ */ t.createElement(N, { ...n[0] }) : null);
}, oe = (e) => {
  const n = e.text.filter(
    (l) => l.type === "additionalText" ? l : null
  );
  return /* @__PURE__ */ t.createElement(t.Fragment, null, n.length > 0 ? /* @__PURE__ */ t.createElement(N, { ...n[0] }) : null);
}, me = (e) => {
  const n = e.text.filter(
    (l) => l.type === "description" ? l : null
  );
  return /* @__PURE__ */ t.createElement(t.Fragment, null, n.length > 0 ? /* @__PURE__ */ t.createElement(N, { ...n[0] }) : null);
}, $ = (e) => {
  let n = [];
  if (e.labels && e.labels.length > 0)
    for (let l = 0; l < e.labels.length; l++) {
      let a = {};
      if (a.isOpaque = e.labels[l].isOpaque, a.color = e.labels[l].color, a.backgroundColor = e.labels[l].backgroundColor, a.textColor = e.labels[l].textColor, a.customBackgroundColor = e.labels[l].customBackgroundColor, a.cutStyle = e.labels[l].cutStyle, !e.labels[l].isMulti)
        a.title = e.labels[l].title;
      else {
        a.title = [];
        let c = {};
        for (c.type = e.labels[l].isHighlight ? "price" : e.labels[l].isStrikeThrough ? "price-old" : "description", c.value = e.labels[l].title, a.title.push(c); e.labels[l + 1] && l < e.labels.length && e.labels[l].isMulti; ) {
          let i = {};
          i.type = e.labels[l + 1].isHighlight ? "price" : e.labels[l + 1].isStrikeThrough ? "price-old" : "description", i.value = e.labels[l + 1].title, a.title.push(i), l++;
        }
      }
      n.push(a);
    }
  return /* @__PURE__ */ t.createElement(t.Fragment, null, n && n.length > 0 ? /* @__PURE__ */ t.createElement("ul", { className: "labels " + e.labelsClassName }, n.map(
    (l, a) => l.title !== "<no-mobile>" ? /* @__PURE__ */ t.createElement(
      "li",
      {
        key: e.uuid + a,
        className: typeof l.title == "object" ? "spot" : ""
      },
      /* @__PURE__ */ t.createElement(ue, { label: l, idx: a })
    ) : null
  )) : null);
}, ue = ({ label: e, idx: n }) => {
  let l = null;
  if (e.customBackgroundColor.length !== 0) {
    let a = e.customBackgroundColor.split(" ");
    l = {
      backgroundColor: `#${a[0]}`,
      color: a[1] ? `#${a[1]}` : ""
    };
  }
  return /* @__PURE__ */ t.createElement(
    t.Fragment,
    null,
    /* caso AC */
    e.dataStyles ? /* @__PURE__ */ t.createElement(
      "span",
      {
        "data-labelcolor": e.dataStyles,
        "data-label": e.title && e.title
      }
    ) : (
      /* caso Multi label */
      typeof e.title == "object" && e.title.length > 0 ? /* @__PURE__ */ t.createElement(
        "span",
        {
          className: `${e.color && e.color} ${e.backgroundColor && e.backgroundColor} ${e.cutStyle ? e.cutStyle : ""}`,
          style: l
        },
        e.title.map((a, c) => /* @__PURE__ */ t.createElement(de, { key: n + "-" + c, text: a }))
      ) : (
        /* caso Single label */
        e.title.length > 0 && /* @__PURE__ */ t.createElement(
          "span",
          {
            className: `${e.color && e.color} ${e.backgroundColor && e.backgroundColor} ${e.cutStyle ? e.cutStyle : ""}`,
            style: l,
            dangerouslySetInnerHTML: {
              __html: e.title && e.title
            }
          }
        )
      )
    )
  );
}, de = (e) => {
  const n = { __html: e.text.value };
  switch (e.text.type) {
    case "description":
      return /* @__PURE__ */ t.createElement("span", { className: "spot-text", dangerouslySetInnerHTML: n });
    case "price":
      return /* @__PURE__ */ t.createElement("span", { className: "spot-text price", dangerouslySetInnerHTML: n });
    case "price-old":
      return /* @__PURE__ */ t.createElement(
        "span",
        {
          className: "spot-text price-old",
          dangerouslySetInnerHTML: n
        }
      );
    default:
      return null;
  }
};
export {
  be as ImageBuilder,
  _e as ImageWrapBuilder,
  de as ItemLabelBuilder,
  N as ItemTextBuilder,
  $ as LabelWrpBuilder,
  p as LinkWrapper,
  oe as SetAdditionalText,
  me as SetDescription,
  M as SetIcons,
  re as SetIconsImage,
  ue as SetLabels,
  ce as SetSubTitle,
  ie as SetTitle,
  Ie as TextHolderBuilder,
  Le as TextHolderBuilderV2
};
